import { api } from './api/api.module';
import { date } from './date/date.module';
import { googleAnalytics } from './google-analytics/google-analytics.module';
import { slug } from './slug/slug.module';
export const libs = angular
	.module('common.libs', [
		api,
		date,
		googleAnalytics,
		slug
	])
	.name;


// WEBPACK FOOTER //
// ./src/app/common/libs/libs.module.js